import { useState, useMemo } from 'react';
import { Box, H3, Link } from '@bigcommerce/big-design';
import { AddonsColumn, DescriptionColumn, VehicleColumn } from './Columns';
import Table from '../../../../components/Table';
import { createDefaultRenderer, getProductsAndAddons } from '../../../../utils';

const tableColumns = [
	{ hash: 'vehicle', header: 'Vehicle', render: VehicleColumn },
	{
		hash: 'vendor',
		header: 'Vendor',
		render: createDefaultRenderer('vendor', 'N/A'),
	},
	{
		hash: 'product_name',
		header: 'Product Name',
		render: createDefaultRenderer('product_name', 'N/A'),
	},
	{
		hash: 'color',
		header: 'Color',
		render: createDefaultRenderer('color', 'N/A'),
	},
	{ hash: 'row', header: 'Row', render: createDefaultRenderer('row', 'N/A') },
	{ hash: 'description', header: 'Description', render: DescriptionColumn },
	{
		hash: 'row_comment',
		header: 'Note',
		render: createDefaultRenderer('row_comment', 'N/A'),
	},
	{
		hash: 'part_number',
		header: 'Part Number',
		render: createDefaultRenderer('part_number', 'N/A'),
	},
	{
		hash: 'quantity',
		header: 'Quantity',
		render: createDefaultRenderer('quantity', 'N/A'),
	},
	{ hash: 'addons', header: 'Add Ons', render: AddonsColumn },
];

export function OrderSummary({ products }) {
	const numberToCollapseAfter = 3;
	const [collapsed, setCollapsed] = useState(true);
	const allProducts = useMemo(
		() => getProductsAndAddons(products),
		[products],
	);
	const displayedProducsts = collapsed
		? allProducts.slice(0, numberToCollapseAfter)
		: allProducts;

	return (
		<>
			<H3>Summary/Confirmation</H3>
			<Table columns={tableColumns} items={displayedProducsts} />
			{allProducts.length > numberToCollapseAfter && (
				<Box marginTop="small" marginBottom="medium">
					<Link onClick={() => setCollapsed(!collapsed)}>
						{collapsed ? 'Show More' : 'Show Less'}
					</Link>
				</Box>
			)}
		</>
	);
}
